module.exports = __webpack_public_path__ + "img/textNo1.dfd72243.jpg";